import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/Gearbox/1_1x.png`;
const Pic2 = `${FullPath}/Gearbox/2_1x.png`;
const Pic3 = `${FullPath}/Gearbox/3_1x.png`;
const Pic4 = `${FullPath}/Gearbox/4_1x.png`;
const Pic5 = `${FullPath}/Gearbox/5_1x.png`;
const Pic6 = `${FullPath}/Gearbox/6_1x.png`;
const Pic7 = `${FullPath}/Gearbox/7_1x.png`;
const Pic8 = `${FullPath}/Gearbox/8_1x.png`;
const Pic9 = `${FullPath}/Gearbox/9_1x.png`;
const Pic10 = `${FullPath}/Gearbox/10_1x.png`;
const Pic11 = `${FullPath}/Gearbox/11_1x.png`;
const Pic12 = `${FullPath}/Gearbox/12_1x.png`;
const Pic13 = `${FullPath}/Gearbox/13_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}